import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const firmLocaleModule: LocaleModule = {
  name: "firm",
  messages: { en: en, it: it },
};
